module.exports = __webpack_public_path__ + "static/media/strenght-shapes-mobile-pale.eb993ee3.svg";